<template>
  <div>
    <img :src="src" width="150" height="150" style="" />
    <el-dialog
      v-model="pwdFalseShow"
      width="27%"
      class="errDia"
      :before-close="handleClose"
      title="提示"
    >
      <div style="text-align: center">
        <p>
          您的密码不符合相关要求，请<router-link
            to="/ChangePassword"
            style="color: red"
            >点击此处</router-link
          >修改密码。
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../utils/gogocodeTransfer'
var timeStop
export default {
  name: 'Login_WeiXin',
  data() {
    return {
      src: '',
      carousel: '',
      Code: '',
      timeStop: '',
      pwdFalseShow: false,
    }
  },
  props: ['dialogVisible', 'type'],
  deactivated() {
    window.clearInterval(timeStop)
  },
  async mounted() {
    let carousel = await this.$store.dispatch('_getGetQrcode')
    if (carousel) {
      this.src = carousel.data.Url
      this.Code = carousel.data.Code
      this.handleQrcodeCheck(this.type)
      this.$parent.loading = false
      $emit(this, 'func', this.src)
    }
  },
  methods: {
    handleQrcodeCheck(type) {
      //        if(type==2){
      //            let  appid = "wxdcaadfbc36ca5584";
      //   let redirect_uri = encodeURIComponent('http://beta.samsoncn.com')
      //   window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATUS#wechat_redirect`

      //        }else
      if (type == 1) {
        timeStop = window.setInterval(() => {
          this.$store
            .dispatch('_getWeiXinLogin', { Scene: this.Code })
            .then((res) => {
              if (res.data.IsSuccess) {
                if (!res.data.Data.IsGo) {
                  this.pwdFalseShow = true
                  return
                }
                this.$message({ message: '登录成功', type: 'success' })
                localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
                var urldomain = '/'
                window.location.href = urldomain
                $emit(this, 'fuab', false)
              }
            })
        }, 2000)
      }
    },
  },
  emits: ['func', 'fuab'],
}
</script>

<style scoped></style>
